export default "__VITE_ASSET__a977659e__"